<template>
  <div class="">
    <div class="d-flex justify-content-between mode-btn-container">
    <div class="d-flex justify-content-center w-100 mode-item gap-10"  @click="switchTool('texttoimage')" v-bind:class="{ 'active': this.creatorStudio.settings.activeTool === 'texttoimage' || this.creatorStudio.settings.activeTool == null}">
      <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path id="Vector" d="M10.7857 1.85711V1.35711H10.2857H6.85714H6.35714V1.85711V12.1428V12.6428H6.85714H7.71429C7.80901 12.6428 7.89985 12.6804 7.96682 12.7474C8.0338 12.8144 8.07143 12.9052 8.07143 13C8.07143 13.0947 8.0338 13.1855 7.96682 13.2525C7.89985 13.3195 7.80901 13.3571 7.71429 13.3571H4.28571C4.19099 13.3571 4.10015 13.3195 4.03318 13.2525C3.9662 13.1855 3.92857 13.0947 3.92857 13C3.92857 12.9052 3.9662 12.8144 4.03318 12.7474C4.10015 12.6804 4.19099 12.6428 4.28571 12.6428H5.14286H5.64286V12.1428V1.85711V1.35711H5.14286H1.71429H1.21429V1.85711V3.57139C1.21429 3.66611 1.17666 3.75695 1.10968 3.82393L1.46323 4.17748L1.10968 3.82393C1.0427 3.89091 0.951863 3.92854 0.857143 3.92854C0.762423 3.92854 0.671582 3.89091 0.604605 3.82393C0.537627 3.75695 0.5 3.66611 0.5 3.57139V0.999965C0.5 0.905245 0.537627 0.814405 0.604605 0.747427C0.671582 0.68045 0.762423 0.642822 0.857143 0.642822H11.1429C11.2376 0.642822 11.3284 0.68045 11.3954 0.747426L11.7476 0.395221L11.3954 0.747427C11.4624 0.814404 11.5 0.905244 11.5 0.999965V3.57139C11.5 3.66611 11.4624 3.75695 11.3954 3.82393L11.7489 4.17748L11.3954 3.82393C11.3284 3.89091 11.2376 3.92854 11.1429 3.92854C11.0481 3.92854 10.9573 3.89091 10.8903 3.82393L10.5368 4.17748L10.8903 3.82393C10.8233 3.75695 10.7857 3.66611 10.7857 3.57139V1.85711Z" fill="#2E2E2E" stroke="#E8EAED"/>
      </svg>
      From Text
    </div>
      <div class="d-flex justify-content-center w-100 mode-item gap-10"  @click="switchTool('similiarimage')" v-bind:class="{ 'active': this.creatorStudio.settings.activeTool === 'similiarimage'}">
      <i class="far fa-image"></i> From Image
    </div>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin';
import CreditManager from '../../manager/CreditManager';
import ImagesManager from '../../manager/ImagesManager';
import { EVENT_JOB_START } from '../../events/job.events';
import { EventBus } from '../../events/event.bus';
import currentJob from './../../mixins/current_job.mixin';
import CoinSVG from './../../../form/icons/CoinSVG.vue';
import TextInput from "../../../form/TextInput.vue";
import Analytics from "../../util/Analytics";

export default {
  name: 'ModeSelector',
  props: {},
  components: {TextInput},
  mixins: [store, currentJob],
  data() {
    return {};
  },
  mounted: function () {
    if (typeof this.creatorStudio.settings.activeTool === 'undefined') {
      this.creatorStudio.settings.activeTool = 'texttoimage';
    }
    if (typeof this.creatorStudio.settings.similiarImageJob === 'undefined') {
      this.creatorStudio.settings.similiarImageJob = {
        apiJob: {},
        progress: null,
      };
    }
  },
  created: function () {},
  methods: {
    switchTool(tool) {
      Analytics.send('creator_studio_action', `switch_mode`, this.currentJob);

      this.creatorStudio.settings.activeTool = tool;
    }
  },
  computed: {
  },
};
</script>
<style lang="scss" scoped>
.mode-btn-container {
  :first-child {
  border-radius: 18px 0 0 18px;
  }
  :last-child {
    border-radius: 0 18px 18px 0;
  }
}
.mode-item {
  background: #383838;
  font-weight: bold;
  height: 38px;
  align-items: center;
  &.active {
    background: #1266F1 !important;
  }
}
</style>
